<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs :append="[editData.username]" />
          <info-menu :is-new="isNew" :read-only.sync="infoReadonly" />
          <div class="basic-information">
            <!-- 虚线验证在form 加 error-form ref="editDataForm":rules="rules"-->
            <el-form class="error-form basic-table basic-table-div" :disabled="isSnapshot">
              <el-collapse v-model="activeNames">
                <!--基本信息start-->
                <el-collapse-item title="基本信息" name="basicInfo">
                  <el-row>
                    <el-col :span="2">姓名</el-col>
                    <el-col :span="4">
                      <el-input :disabled="infoReadonly && !canEditByCreator" class="jm-input175" v-model="editData['username']" autofocus="autofocus" />
                    </el-col>
                    <el-col :span="2">昵称</el-col>
                    <el-col :span="4">
                      <el-input :disabled="infoReadonly && !canEditByCreator" class="jm-input175" v-model="editData['nickname']" />
                    </el-col>
                    <el-col :span="2">采集功能</el-col>
                    <el-col :span="4">
                      <el-select v-if="isNew" v-model="editData['create_point']" filterable class="jm-input175" clearable
                                 placeholder="请选择">
                        <el-option-group
                          v-for="(group, k) in ds.create_person"
                          :key="k"
                          :label="k">
                          <el-option
                            v-for="item in group"
                            v-if="item.userid < 0"
                            :key="item.userid"
                            :label="item.username"
                            :value="item.userid"/>
                        </el-option-group>
                      </el-select>
                      <span v-else>{{ editData.create_point_value }}</span>
                      <span v-if="!isNew">({{ editData.create_time }})</span>
                    </el-col>
                    <el-col :span="2">推广人</el-col>
                    <el-col :span="4">
                      <el-select v-if="isNew && isTrainingSite || $hasPermission([])" v-model="editData['custom_promoter']" filterable class="jm-input175" clearable
                                 placeholder="请选择">
                        <el-option-group
                          v-for="(group, k) in ds.create_person"
                          :key="k"
                          :label="k">
                          <el-option
                            v-for="item in group"
                            v-if="item.userid > 0"
                            :key="item.userid"
                            :label="item.username"
                            :value="item.userid"/>
                        </el-option-group>
                      </el-select>
                      <span v-else>{{ editData.custom_promoter_value }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">电话</el-col>
                    <el-col :span="8">
                      <el-form-item prop="tel">
                        <el-input
                          style="float:left"
                          ref="telInput"
                          :disabled="(infoReadonly && !canEditByCreator) || (!isNew && $hasPermission(80, true) && !!originData['tel'])"
                          class="jm-input175"
                          @blur="checkTel"
                          v-model.trim="editData['tel']">
                        </el-input>
                        <Copy
                          style="float:left"
                          v-if="(infoReadonly && !canEditByCreator) || (!isNew && $hasPermission(80, true) && !!originData['tel'])"
                          :content="editData.tel"
                          @copyCallback="copyClick()">
                          <el-button size="small" style="height:36px">复制</el-button>
                        </Copy>
                        <em style="float:left;padding-left:20px">&nbsp; 归属地区：{{ editData.crm_tel_province }} {{ editData.crm_tel_city }}</em>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1">QQ</el-col>
                    <el-col :span="3">
                      <el-form-item prop="qq">
                        <el-input
                          :disabled="(infoReadonly && !canEditByCreator) || (!isNew && $hasPermission(80, true) && !!originData['qq'])"
                          class="jm-input175"
                          :maxlength="20"
                          v-model.trim="editData['qq']">
                          <!-- <el-button slot="append">x</el-button> -->
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1">微信</el-col>
                    <el-col :span="4">
                      <el-form-item prop="wechat">
                        <el-input
                          style="float:left"
                          :disabled="(infoReadonly && !canEditByCreator) || (!isNew && $hasPermission(80, true) && !!originData['wechat'])"
                          class="jm-input175"
                          v-model.trim="editData['wechat']" />
                        <Copy
                          style="float:left"
                          v-if="(infoReadonly && !canEditByCreator) || (!isNew && $hasPermission(80, true) && !!originData['wechat'])"
                          :content="editData.wechat"
                          @copyCallback="copyClick()">
                          <el-button size="small" style="height:36px">复制</el-button>
                        </Copy>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1">性别</el-col>
                    <el-col :span="4">
                      <jm-dict-select :disabled="infoReadonly && !canEditByCreator" class="jm-input175" clearable v-model="editData['gender']" dict="dataset.student.gender" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">是否已添加微信</el-col>
                    <el-col :span="22">
                      <el-switch
                        active-text="是"
                        inactive-text="否"
                        active-value="1"
                        inactive-value="0"
                        v-model="editData['take_wechat']"/>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">渠道来源</el-col>
                    <el-col :span="16">
                      <jm-channel ref="channelRef" :disabled="!$hasPermission(1) && !isNew" v-if="isTrainingSite" :exclude-disable="!$hasPermission(1) && !isNew" :is-all="false" :final.sync="channelFinal"
                                  v-model="channelModel" clearable filter />
                      <template v-else>
                        {{ editData.channelsData }}
                      </template>
                    </el-col>
                    <el-col :span="2">运营情况</el-col>
                    <el-col :span="4">
                      <jm-dict-select class="jm-input175" clearable v-model="editData['op_status']" dict="dataset.student.opStatus" @change="opChange"/>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">意向部门</el-col>
                    <el-col :span="6">
                      <div style="float:left;">
                        <el-checkbox-group v-model="editData['target_country']" ref="targetCountryRef" :disabled="infoReadonly">
                          <el-checkbox label="1868">考培</el-checkbox>
                          <el-checkbox label="2044" disabled>英澳培训</el-checkbox>
                          <!-- <el-checkbox label="1944" disabled>高考日语线上</el-checkbox> -->
                          <!-- <el-checkbox label="2043" disabled>高考日语线下</el-checkbox> -->
                        </el-checkbox-group>
                      </div>
                    </el-col>
                    <el-col :span="2">线索画像</el-col>
                    <el-col :span="14">
                      <template v-if="editData['nseries_tags']">
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['jp_purpose']" type="danger">学习目的 {{ editData['nseries_tags']['jp_purpose'] }}</el-tag>
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['social_identity']" type="danger">用户身份 {{ editData['nseries_tags']['social_identity'] }}</el-tag>
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['level_now']" type="danger">当前等级 {{ editData['nseries_tags']['level_now'] }}</el-tag>
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['level_target']" type="danger">需达到等级 {{ editData['nseries_tags']['level_target'] }}</el-tag>
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['area']" type="danger">{{ editData['nseries_tags']['area'] }}</el-tag>
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['mobile_brand']" type="danger">机型 {{ editData['nseries_tags']['mobile_brand'] }}</el-tag>
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['date_time']" type="danger">App注册时间 {{ editData['nseries_tags']['date_time'] }}</el-tag>
                      </template>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">就读学校</el-col>
                    <el-col :span="6">
                      <jm-dict-select v-model="editData['school_type']" clearable class="jm-input135" type="dataset"
                                      dict-type="student" name="schoolType" :filter="(item) => { return item.value > 0; }"
                                      :disabled="infoReadonly /* */" />
                      <el-input class="jm-input175" v-model="editData['school_name']" :disabled="infoReadonly" />
                    </el-col>
                    <el-col :span="2">就读专业</el-col>
                    <el-col :span="6">
                      <jm-dict-select v-model="editData['edu_major']" clearable class="jm-input135" type="dataset"
                                      dict-type="student" name="majorType" :disabled="infoReadonly" />
                      <el-input class="jm-input175" v-model="editData['edu_major_name']" :disabled="infoReadonly /* */" />
                    </el-col>
                    <el-col :span="2">最高学历</el-col>
                    <el-col :span="6">
                      <jm-education-select clearable v-model="editData['education']" :disabled="infoReadonly /* */" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">邮寄地址</el-col>
                    <el-col :span="6">
                      <el-form-item prop="post_address">
                        <el-input class="jm-input500" v-model.trim="editData['post_address']"
                                  :disabled="infoReadonly /* */" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="2">是否建联成功</el-col>
                    <el-col :span="6">
                      <jm-dict-select class="jm-input175" clearable v-model="editData['hand']" dict="dataset.student.isHand" />
                    </el-col>
                    <el-col :span="2">考试时间</el-col>
                    <el-col :span="6">
                      <el-date-picker
                        v-model="editData['exam_date']"
                        value-format="yyyy-MM"
                        type="month"
                        placeholder="请选择">
                      </el-date-picker>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">备注</el-col>
                    <el-col :span="22">
                      <el-input class="training-memo" type="textarea" :rows="2" placeholder="请输入备注" v-model="editData['memo']" :disabled="infoReadonly /* */"/>
                    </el-col>
                  </el-row>
                  <el-row v-if="editData['sync'] && editData['sync'].length >= 1">
                    <el-col>
                      <div class="red">
                        <p v-for="(sync, k) in editData['sync']" :key="k">【资源内推{{ sync.create_time }}】{{ sync.sender_department }}-{{ sync.sender }}老师给您留言：{{ sync.note }}</p>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div style="font-size: 20px; font-weight: bold; padding: 0 10px">资源复用记录</div>
                    </el-col>
                    <el-col :span="24">
                      <jm-tableList
                        style="width: 100%"
                        url="/index/reuse/getList"
                        :search-data="{userid: $route.params.id, origin_tag: siteName}"
                        row-key="id"
                      >
                        <el-table-column
                          slot="url"
                          label="截图"
                          min-width="80">
                          <template slot-scope="scope">
                            <img style="max-height: 40px; cursor: pointer" @click="viewBigImg(scope.row.url)" :src="scope.row.url" alt="">
                          </template>
                        </el-table-column>
                      </jm-tableList>
                    </el-col>
                  </el-row>
                </el-collapse-item>
                <!--基本信息end-->

                <!--语言信息start-->
                <el-collapse-item title="语言信息" name="language">
                  <el-row>
                    <el-col :span="2">意向语言</el-col>
                    <el-col :span="10">
                      <div style="float:left;">
                        <el-checkbox-group v-model="editData['target_lan']" :disabled="infoReadonly /* */">
                          <el-checkbox label="日语" ></el-checkbox>
                          <el-checkbox label="韩语" ></el-checkbox>
                          <el-checkbox label="雅思" ></el-checkbox>
                          <el-checkbox label="托福" ></el-checkbox>
                          <el-checkbox label="PTE" ></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </el-col>
                    <el-col :span="2">目的地国家</el-col>
                    <el-col :span="10">
                      <el-select v-model="editData['destination_country']" clearable>
                        <el-option
                          v-for="item in hopeCountries"
                          :label="item.value"
                          :key="item.id"
                          :value="item.id"
                          v-if="[2069, 1880, 1882, 1938, 1943, 1944, 2040, 2042, 2043, 2070, 1868, 2044, 675, 2130].indexOf(item.id) === -1"/>
                      </el-select>
                    </el-col>
                  </el-row>
                </el-collapse-item>
                <!--语言信息end-->

                <!--日语学习属性start-->
                <el-collapse-item title="日语学习属性" name="japanese" v-show="editData.target_lan.indexOf('日语') !== -1">
                  <el-row>
                    <el-col :span="2">日语基础</el-col>
                    <el-col :span="6">
                      <jm-dict-select v-model="editData['japanese_level']" class="jm-input220" clearable type="dataset"
                                      dict-type="training" name="basicJapanese" :disabled="infoReadonly /* */" />
                    </el-col>
                    <el-col :span="2">学习动机</el-col>
                    <el-col :span="6">
                      <jm-dict-select v-model="editData['study_motive']" class="jm-input220" clearable type="dataset"
                                      dict-type="training" name="learningMotivation" :disabled="infoReadonly /* */" />
                    </el-col>
                    <el-col :span="2">学习目标</el-col>
                    <el-col :span="6">
                      <jm-examjp-select v-model="editData['study_goal']" clearable :disabled="infoReadonly /* */" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">推荐课程</el-col>
                    <el-col :span="6">
                      <el-input v-model="editData['recommend_lesson_jp']" class="jm-input220" :disabled="infoReadonly /* */" />
                    </el-col>
                    <el-col :span="2">方便上课时间</el-col>
                    <el-col :span="14">
                      <el-input type="textarea" :rows="1" v-model="editData['student_lesson_time']" :disabled="infoReadonly /* */" />
                    </el-col>
                  </el-row>
                </el-collapse-item>
                <!--日语学习属性end-->

                <!--韩语学习属性start-->
                <el-collapse-item title="韩语学习属性" name="korea" v-show="editData.target_lan.indexOf('韩语') !== -1">
                  <el-row>
                    <el-col :span="2">韩语基础</el-col>
                    <el-col :span="6">
                      <jm-dict-select v-model="editData['korea_level']" class="jm-input220" clearable type="dataset"
                                      dict-type="training" name="basicKorea" :disabled="infoReadonly" />
                    </el-col>
                    <el-col :span="2">学习动机</el-col>
                    <el-col :span="6">
                      <jm-dict-select v-model="editData['study_motive_kr']" class="jm-input220" clearable type="dataset"
                                      dict-type="training" name="learningMotivation" :disabled="infoReadonly" />
                    </el-col>
                    <el-col :span="2">学习目标</el-col>
                    <el-col :span="6">
                      <jm-studytarget-select v-model="editData['study_goal_kr']" clearable :disabled="infoReadonly" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">推荐课程</el-col>
                    <el-col :span="6">
                      <el-input v-model="editData['recommend_lesson_kr']" class="jm-input220" :disabled="infoReadonly" />
                    </el-col>
                    <el-col :span="2">方便上课时间</el-col>
                    <el-col :span="14">
                      <el-input type="textarea" :rows="1" v-model="editData['student_lesson_time_kr']" :disabled="infoReadonly" />
                    </el-col>
                  </el-row>
                </el-collapse-item>
                <!--韩语学习属性end-->

                <!--英语学习属性start-->
                <el-collapse-item title="英语学习属性" name="english"
                                  v-show="editData.target_lan.indexOf('雅思') !== -1 || editData.target_lan.indexOf('托福') !== -1 || editData.target_lan.indexOf('PTE') !== -1">
                  <el-row>
                    <el-col :span="2" class="scores-info">
                      <el-row>
                        <el-col>英语成绩</el-col>
                        <el-col />
                        <el-col />
                      </el-row>
                    </el-col>
                    <el-col :span="22" class="scores-jmte">
                      <el-row style="width: 100%; display: block;">
                        <el-col :span="24">
                          <span class="jm-span">『 IELTS 』</span>
                          L：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_IELTS]['listening']" :disabled="infoReadonly" />
                          R：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_IELTS]['reading']" :disabled="infoReadonly" />
                          W：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_IELTS]['writing']" :disabled="infoReadonly" />
                          S：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_IELTS]['speaking']" :disabled="infoReadonly" />
                          总：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_IELTS]['total']" :disabled="infoReadonly" />
                        </el-col>

                        <el-col :span="24">
                          <span class="jm-span">『 PTE 』</span>
                          L：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_PTE]['listening']" :disabled="infoReadonly" />
                          R：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_PTE]['reading']" :disabled="infoReadonly" />
                          W：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_PTE]['writing']" :disabled="infoReadonly" />
                          S：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_PTE]['speaking']" :disabled="infoReadonly" />
                          总：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_PTE]['total']" :disabled="infoReadonly" />
                        </el-col>
                        <el-col :span="24">
                          <span class="jm-span">『 GRE 』</span>
                          数：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_GRE]['math']" :disabled="infoReadonly" />
                          语：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_GRE]['language']" :disabled="infoReadonly" />
                          写：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_GRE]['writing']" :disabled="infoReadonly" />
                          总：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_GRE]['total']" :disabled="infoReadonly" />
                        </el-col>
                      </el-row>
                      <el-row style="width: 100%; display: block;">
                        <el-col :span="24">
                          <span class="jm-span">『 TOEFL 』</span>
                          L：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_TOEFL]['listening']" :disabled="infoReadonly" />
                          R：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_TOEFL]['reading']" :disabled="infoReadonly" />
                          W：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_TOEFL]['writing']" :disabled="infoReadonly" />
                          S：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_TOEFL]['speaking']" :disabled="infoReadonly" />
                          总：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_TOEFL]['total']" :disabled="infoReadonly" />
                        </el-col>

                        <el-col :span="24">
                          <span class="jm-span">『 GMAT 』</span>
                          写：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_GMAT]['writing']" :disabled="infoReadonly" />
                          综：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_GMAT]['integration']" :disabled="infoReadonly" />
                          数：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_GMAT]['math']" :disabled="infoReadonly" />
                          语：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_GMAT]['language']" :disabled="infoReadonly" />
                          总：
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_GMAT]['total']" :disabled="infoReadonly" />
                        </el-col>
                        <el-col :span="24">
                          <span class="jm-span">『 CET-4 』</span>
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_CET]['four']" :disabled="infoReadonly" />
                          <span class="jm-span">『 CET-6 』</span>
                          <el-input class="jm-input65" v-model.number="scores[examConst.EXAM_CET]['six']" :disabled="infoReadonly" />
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2" class="scores-info">
                      <el-row>
                        <el-col>学习目标</el-col>
                        <el-col />
                      </el-row>
                    </el-col>
                    <el-col :span="22" class="scores-jmte">
                      <el-row style="width: 100%; display: block;">
                        <el-col :span="24" >
                          <span>『 IELTS  』总分:</span>
                          <el-input class="jm-input65" v-model.number="editData['target_ielts']" :disabled="infoReadonly" />
                          <span>『 PTE 』总分:</span>
                          <el-input class="jm-input65" v-model.number="editData['target_pte']" :disabled="infoReadonly" />
                          <span>『 GRE  』总分:</span>
                          <el-input class="jm-input65" v-model.number="editData['target_gre']" :disabled="infoReadonly" />
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="22" class="scores-jmte">
                      <el-row style="width: 100%; display: block;">
                        <el-col :span="24" >
                          <span>『 TOEFL 』总分:</span>
                          <el-input class="jm-input65" v-model.number="editData['target_tofel']" :disabled="infoReadonly" />
                          <span>『 GMAT  』总分:</span>
                          <el-input class="jm-input65" v-model.number="editData['target_gmat']" :disabled="infoReadonly" />
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">学习动机</el-col>
                    <el-col :span="22">
                      <jm-dict-select v-model="editData['study_motive_en']" class="jm-input220" clearable type="dataset"
                                      dict-type="training" name="learningMotivation" :disabled="infoReadonly" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">推荐课程</el-col>
                    <el-col :span="6">
                      <el-input v-model="editData['recommend_lesson_en']" class="jm-input220" :disabled="infoReadonly" />
                    </el-col>
                    <el-col :span="2">方便上课时间</el-col>
                    <el-col :span="14">
                      <el-input type="textarea" :rows="1" v-model="editData['student_lesson_time_en']" :disabled="infoReadonly" />
                    </el-col>
                  </el-row>
                </el-collapse-item>
                <!--英语学习属性end-->

                <!--签约信息start-->
                <el-collapse-item title="签约信息" name="signInfo" :disabled="infoReadonly">
                  <el-row>
                    <el-col :span="2">
                      <template>客户状态</template>
                    </el-col>
                    <el-col :span="6">
                      <jm-dict-select
                        clearable type="dataset" dict-type="training" :disabled="infoReadonly /* */"
                        name="trainingLevelType" v-model="editData['customer_status']" />
                    </el-col>
                    <el-col :span="2">签约日期</el-col>
                    <el-col :span="6">
                      <el-date-picker v-model="editData['sign_date']" class="jm-input220" format="yyyy-MM-dd" :disabled="infoReadonly /* */"
                                      value-format="yyyy-MM-dd" type="date" ref="signData" placeholder="选择日期" />
                    </el-col>
                    <el-col :span="2">意向分级</el-col>
                    <el-col :span="6">
                      <jm-dict-select v-model="editData['customer_classify']" class="jm-input220" type="dataset"
                                      dict-type="training" name="trainingLvType" :disabled="infoReadonly && notEditTrainingLvType" />
                      <el-tooltip placement="top">
                        <div slot="content">
                          A：高意向，预计近一两天成交；<br>
                          B：中高意向，预计周内成交；<br>
                          C：介绍完课程，预计月内成交；<br>
                          D：介绍完课程，暂时无购课意向；<br>
                          E：与线索没有握上手；
                        </div>
                        <el-button type="primary" circle style="width: 20px;height:20px;text-align: center;font-weight: bold;font-size: 16px;padding: 0;margin-left: 5px;">?</el-button>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">咨询老师</el-col>
                    <el-col :span="6">
                      <el-select
                        v-model="editData['training_teacher']"
                        :disabled="teacherModifyDisable"
                        class="jm-input220"
                        filterable
                        placeholder="请选择">
                        <el-option-group
                          v-for="(group, k) in trainingTeachers"
                          :key="k"
                          :label="k">
                          <el-option
                            v-for="(item,k1) in group"
                            :key="k1"
                            :label="item.truename"
                            :value="item.userid"/>
                        </el-option-group>
                      </el-select>
                      分配咨询时间：{{ editData['change_teacher_time'] }}
                    </el-col>
                    <el-col :span="2">签约金额</el-col>
                    <el-col :span="6">
                      <el-input class="jm-input220" v-model="editData['contracted_money']" :disabled="infoReadonly" />
                    </el-col>
                    <el-col :span="2">留学咨询老师</el-col>
                    <el-col :span="6">
                      <el-input class="jm-input220" v-model="editData['crm_sayer_name']" :disabled="true" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">用户运营老师</el-col>
                    <el-col :span="6">
                      <el-select
                        v-model="editData['op_teacher']"
                        class="jm-input220"
                        filterable
                        placeholder="请选择">
                        <el-option
                          label="未分配"
                          :value="0"
                        />
                        <el-option-group
                          v-for="(group, k) in opTeachers"
                          :key="k"
                          :label="k">
                          <el-option
                            v-for="item in group"
                            :key="item.userid"
                            :label="item.truename"
                            :value="item.userid"/>
                        </el-option-group>
                      </el-select>
                      分配运营老师时间：{{ editData['op_createtime_fix'] }}
                    </el-col>
                    <el-col :span="2">介绍人编码</el-col>
                    <el-col :span="6">
                      <el-input class="jm-input220" v-model="editData['introducer_id']" :disabled="canEditIntroducerId" placeholder="填写本系统的资源编码" />
                    </el-col>
                    <el-col :span="2">介绍人姓名</el-col>
                    <el-col :span="6">
                      <el-input class="jm-input220" v-model="editData['introducer_name']" :disabled="true" placeholder="" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">教务老师</el-col>
                    <el-col :span="6">
                      <el-select
                        v-model="editData['jw_teacher']"
                        class="jm-input220"
                        filterable
                        ref="jw_teacher"
                        placeholder="请选择">
                        <el-option
                          label="未分配"
                          :value="0"
                        />
                        <el-option-group
                          v-for="(group, k) in jwTeachers"
                          :key="k"
                          :label="k">
                          <el-option
                            v-for="item in group"
                            :key="item.userid"
                            :label="item.truename"
                            :value="item.userid"/>
                        </el-option-group>
                      </el-select>
                    </el-col>
                  </el-row>
                  <!--
                  <el-row v-for="(item,index) in signLessonModel" :key="index" >
                    <el-col :span="2">签约课程</el-col>
                    <el-col :span="22">
                      <jm-lesson-select clearable v-model="signLessonModel[index]" :disabled="infoReadonly" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      添加签约课程：
                      <el-button
                        :disabled="infoReadonly"
                        size="small"
                        type="primary"
                        @click="addSignLesson()">添加</el-button>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">备注</el-col>
                    <el-col :span="22">
                      <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editData['sign_memo']" :disabled="infoReadonly" />
                    </el-col>
                  </el-row>
                  -->
                </el-collapse-item>
                <!--签约信息end-->

              </el-collapse>

              <!--按钮start-->
              <!-- 2395902 ：考级用户运营，106：考培助理总监 89：数据分析专员 160：考培组长，117 用户运营-->
              <div class="basic-buttom"
                   v-if="userInfo.userid === 2395902 || (isTrainingSite && !infoReadonly && !$hasPermission(106, true) && !$hasPermission(89, true))|| $hasPermission([160,117], true)">
                <el-button type="success" :loading="saving" @click="save()">保存</el-button>
                <!-- <el-button type="primary" :loading="saving" @click="save(true)">保存并新建</el-button> -->
                <template v-if="!isNew && isTrainingSite && $hasPermission([80, 85, 91])">
                  <el-button type="danger" v-if="!syncDialog.finished" @click="showSyncDialog">同步到其他系统</el-button>
                  <el-button type="success" v-if="syncDialog.linked" @click="showSyncMsgDialog">资源动态提醒</el-button>
                </template>
              </div>
              <!--按钮end-->
            </el-form>
          </div>
          <div v-if="!isNew && !isSnapshot">
            <visit
              title="预约试听"
              :user-id="$route.params.id"
              :data-url="`/training/booking/paginate/userid/${$route.params.id}`"
              delete-url="/training/booking/resource/id"
              type="listenOperate"
              :btn-opt-permission="canEditByCreator || $hasPermission([155, 91,85]) || true"
              :table-opt-permission="!infoReadonly || this.$hasPermission([155, 91,85])"
              :jw_teacher = "editData.jw_teacher"
            />
            <visit
              title="学生回访"
              :user-id="$route.params.id"
              :data-url="`/training/visit/paginate/userid/${$route.params.id}`"
              delete-url="/training/visit/resource/id"
              :btn-opt-permission="!infoReadonly || this.$hasPermission([117,97])"
            />
            <visit
              title="运营回访"
              :user-id="$route.params.id"
              :data-url="`/training/operate_visit/paginate/userid/${$route.params.id}`"
              delete-url="/training/operate_visit/resource/id"
              type="trainingOperate"
              :btn-opt-permission="$hasPermission([117, 84])"
              :table-opt-permission="!infoReadonly || this.$hasPermission(117)"
            />
          </div>
          <div v-if="!isNew && isTrainingSite">
            <div class="bind">
              活动记录
            </div>
            <jm-tableList
              url="/training/customer/showActivityLog"
              :search-data="{userid: $route.params.id}"
              row-key="id"
            >
            </jm-tableList>
          </div>
        </div>
      </div>
    </div>
    <!--106 考培助理总监 89数据分析专员 160考培组长-->
    <el-button
      v-if="!infoReadonly && !$hasPermission(106, true) && !$hasPermission(89, true) || $hasPermission(160, true)"
      class="edit-fixed"
      type="success"
      size="mini"
      :loading="saving"
      @click="save()">保存</el-button>

    <sync-dialogs
      v-if="isTrainingSite"
      @confirm="doSync"
      @loaded="syncDataLoaded"
      :type="syncType"
      width="30%"
      :from="editData.id"
      :visible.sync="syncDialogVisible">
    </sync-dialogs>
    <view-large-image :visible.sync="viewImageLock" :img-url="reuseImage"></view-large-image>
  </div>
</template>

<script>
import tableList from '@/components/data/tableList';
import alertTransfer from '@/components/tool/alertTransfer';
import alertText from '@/components/tool/alertText';
import syncDialogsMixin from '@/components/syncDialogsMixin';
import { CREATOR_TRAINING_TO_FIB, CREATOR_TRAINING_TO_JOB } from '@/const/sync';
import {
  jmAreaselect,
  jmChannel,
  jmEducationSelect,
  jmLessonSelect,
  jmDictSelect,
  jmUploadFile,
  jmExamjpSelect,
  jmStudytargetSelect,
} from '@/components/tool';
import '@/assets/jsmind/js/jsmind.js';
import '@/assets/jsmind/style/jsmind.css';
import studentMixin from '@/pages/student/student.js';
import {
  deepClone,
  delay
} from '@/utils/utils';
import customerApi from '@/training/api/customer';
import ExamConst, * as examConst from '@/const/exam.js';
import infoMenu from '@/components/infoMenu';
import viewLargeImage from '@/components/pop/viewLargeImage';
import ElOption from 'element-ui/packages/select/src/option';

const visit = () => import('@/components/visit');
// 初始化成绩信息
let scores = {};
ExamConst.forEach((item) => {
  scores[item] = {
    total: null
  };
});

export default {
  mixins: [studentMixin, syncDialogsMixin],
  components: {
    ElOption,
    'jm-tableList': tableList,
    'jm-alertTransfer': alertTransfer,
    'jm-alertText': alertText,
    jmChannel,
    jmAreaselect,
    jmEducationSelect,
    jmLessonSelect,
    jmDictSelect,
    jmUploadFile,
    jmExamjpSelect,
    jmStudytargetSelect,
    infoMenu,
    visit,
    viewLargeImage
  },
  beforeRouteEnter(to, from, next) {
    if (to.meta.isNew) {
      next((vm) => {
        vm.setNewCustomerData();
      });
      return true;
    }

    const customerId = to.params.customer_id || to.params.id;
    // 如果是重复资源记录
    if (to.name === 'resourceSnapshot') {
      customerApi.getSnapshotById(customerId).then(({
        data
      }) => {
        next((vm) => {
          vm.setCustomerInfo(data);
          vm.setIsSnapshot(true);
        });
      });
    } else {
      customerApi.getCustomerById(customerId).then(({
        data
      }) => {
        next((vm) => {
          vm.setCustomerInfo(data);
        });
      })
        .catch(() => {
          this.$router.replace({ name: 'resourceManage' });
        });
    }
  },
  data() {
    return {
      syncConfirmVisible: false, // 同步资源对话框
      pushMessageFormVisible: false, // 资源动态提醒对话框
      existsInFib: false, // 蓝火内是否已经有相同手机号
      refresh: false,
      examConst, // 成绩常量
      saving: false,
      channelModel: {}, // 渠道信息
      signLessonModel: [
        {
          sign_lesson_1: null, sign_lesson_2: null, sign_lesson_3: null, sign_lesson_4: null, sign_lesson_5: null,
        },
        {
          sign_lesson_1: null, sign_lesson_2: null, sign_lesson_3: null, sign_lesson_4: null, sign_lesson_5: null,
        },
        {
          sign_lesson_1: null, sign_lesson_2: null, sign_lesson_3: null, sign_lesson_4: null, sign_lesson_5: null,
        },
        {
          sign_lesson_1: null, sign_lesson_2: null, sign_lesson_3: null, sign_lesson_4: null, sign_lesson_5: null,
        },
        {
          sign_lesson_1: null, sign_lesson_2: null, sign_lesson_3: null, sign_lesson_4: null, sign_lesson_5: null,
        },
      ], // 签约课程
      activeNames: [
        // 'english',
        // 'japanese',
        // 'korea',
        'basicInfo',
        'signInfo',
        'language'
      ],
      ds: {},
      editData: {
        id: 0,
        customer_status: 13,
        training_teacher: -1,
        education: [],
        study_goal: [],
        study_goal_kr: [],
        target_lan: [],
        target_country: [],
        recommend_lesson_en: '',
        hand: 0,
        op_status: 0,
        op_createtime_fix: '',
        customer_classify: 0,
        destination_country: '',
        jw_teacher: '',
      },
      originData: {
        tel: '',
        qq: '',
        wechat: ''
      },
      isSnapshot: false, // 是否为重复资源快照
      isNew: false,
      isEdit: true,
      // 分数
      scores: deepClone(scores),
      siteIndex: '1',
      channelFinal: false,
      siteName: process.env.VUE_APP_SITE_NAME,
      viewImageLock: false,
      reuseImage: ''
    };
  },
  methods: {
    opChange(value) {
      // 1有意向或者2需内推，意向分级标签自动变更为B
      if (value !== 3) {
        // console.log(value);
        // this.editData.customer_classify = 51;
      }
    },
    viewBigImg(url) {
      if (url) {
        this.reuseImage = url;
        this.viewImageLock = true;
      } else {
        this.$message.error('图片路径错误');
      }
    },
    resetEditData() {
      this.isNew = true;
      this.editData = {
        customer_status: 13,
        target_lan: [],
        target_country: [],
        training_teacher: Number(this.userInfo.userid),
      };
      this.scores = deepClone(scores);
    },
    /**
     * 保存
     */
    save(isNew = false, showNotify = true) {
      if (!this.hasContactInfo(this.editData.tel, this.editData.wechat)) {
        if (this.editData.id && !this.hasContactInfo(this.editData.qq)) {
          this.$message.error('请填写联系方式');
          this.$refs.telInput.focus();
          return false;
        }
        if (!this.editData.id) {
          this.$message.error('必须填写微信或手机号');
          this.$refs.telInput.focus();
          return false;
        }
      }

      if (this.editData.qq && !this.editData.qq.match(/^\d{5,}$/)) {
        this.$message.error('QQ号码格式错误');
        return false;
      }

      if (!this.hasTargetCountry(this.editData.target_country)) {
        this.$message.error('意向部门至少填写一项');
        // this.$refs.targetCountryRef.focus();
        return false;
      }

      if (!this.hasChannel(this.channelModel)) {
        this.$message.error('渠道来源必须填写');
        this.$refs.channelRef.focus();
        return false;
      } else if (!this.channelFinal) {
        this.$message.error('渠道来源必须填写完全');
        return Promise.reject(new Error('渠道来源必须填写完全'));
      }

      if (this.editData.customer_status === 7 && !this.editData.sign_date) {
        this.$message.error('签约日期不能为空');
        this.$refs.signData.focus();
        return false;
      }

      if (this.isNew === false && this.editData.customer_classify < 50) {
        this.$message.error('请选择意向分级');
        return false;
      }
      // 1（有意向）或者2（需内推），意向分级标签自动变更为C
      // A：高意向，预计近一两天成交；
      // B：中高意向，预计周内成交；
      // C：介绍完课程，预计月内成交；
      // D：介绍完课程，暂时无购课意向；
      // E：与线索没有握上手；
      if (this.editData.op_status === 1 || this.editData.op_status === 2) {
        if (this.editData.customer_classify !== 53) {
          this.editData.customer_classify = 53;
          // 记录通过此方式改变的标识
          this.editData.op_change_classify = 1;
        }
      }
      // 客户状态改为已签约时，教务老师必须选择，不能为空,顾问填写
      if (this.editData.customer_status === 7 && !this.editData.jw_teacher) {
        this.$message.error('请选择教务老师');
        this.$refs.jw_teacher.focus();
        return false;
      }

      this.saving = true;
      return new Promise((resolve, reject) => {
        this.$http._post({
          url: '/training/customer/resource',
          data: this.getData4Save(),
        }).then(({ data }) => {
          this.saving = false;
          showNotify && this.$message.success(data || '保存成功');
          if (isNew || this.isNew) {
            delay(1).then(() => {
              this.$router.push({
                name: 'addCustomer'
              });
              this.resetEditData();
            });
          }
          resolve(data);
        }, ({ data }) => {
          this.saving = false;
          resolve(data);
        }).catch((e) => {
          this.saving = false;
          reject(e);
        });
      });
    },
    setIsSnapshot: function(bool) {
      this.isSnapshot = bool;
    },
    /**
     * 填充学员信息
     *
     * @param {Object} data
     */
    setCustomerInfo(data) {
      if (!data.content_all) {
        data.content_all = {};
      }

      // 学习目标
      data.study_goal = [data.study_goal_type, data.study_goal_level];
      data.study_goal_kr = [data.content_all.study_goal_type_kr || null, data.content_all.study_goal_level_kr || null];

      // 最高学历
      data.education = [data.education_type, data.education_class];
      // 毕业时间
      if (data.graduate_year) {
        data.graduate_year = String(data.graduate_year);
      }
      // 成绩
      if (data.scores) {
        this.scores = Object.assign(this.scores, data.scores.scores);
      }
      // 渠道
      this.channelModel = {
        custom_from: data.custom_from || null,
        custom_from_sub: data.custom_from_sub || null,
        custom_from_thrid: data.custom_from_thrid || null,
        custom_from_fourth: data.custom_from_fourth || null,
        custom_from_fifth: data.custom_from_fifth || null,
      };
      if (!data.target_lan) {
        data.target_lan = [''];
      }
      this.editData = data;
      // 原始数据
      this.originData.tel = this.editData.tel || null;
      this.originData.qq = this.editData.qq || null;
      this.originData.wechat = this.editData.wechat || null;
      // 签约课程
      if (data.content_all.sign_lesson) {
        let j = 0;
        for (let i = 0; i < data.content_all.sign_lesson.length; i++) {
          // this.signLessonModel.push(data.content_all.sign_lesson[i]);
          this.signLessonModel[i] = data.content_all.sign_lesson[i];
          j = i + 1;
        }
        let num = this.signLessonModel.length;
        for (j; j < num; j++) {
          this.signLessonModel.pop();
        }
      } else {
        for (let j = 0; j < 5; j++) {
          this.signLessonModel.pop();
        }
      }
      // 序列化内容
      this.editData.sign_memo = data.content_all.sign_memo || null;
      this.editData.study_motive_en = data.content_all.study_motive_en || null;
      this.editData.student_lesson_time_en = data.content_all.student_lesson_time_en || null;
      this.editData.memo_en = data.content_all.memo_en || null;
      this.editData.recommend_lesson_en = data.content_all.recommend_lesson_en || null;

      this.editData.target_tofel = data.content_all.target_tofel || null;
      this.editData.target_toeic = data.content_all.target_toeic || null;
      this.editData.target_gre = data.content_all.target_gre || null;
      this.editData.target_sat = data.content_all.target_sat || null;
      this.editData.target_ielts = data.content_all.target_ielts || null;
      this.editData.target_cet = data.content_all.target_cet || null;
      this.editData.target_gmat = data.content_all.target_gmat || null;
      this.editData.target_act = data.content_all.target_act || null;
      this.editData.target_pte = data.content_all.target_pte || null;

      this.editData.korea_level = data.content_all.korea_level || null;
      this.editData.study_motive_kr = data.content_all.study_motive_kr || null;
      this.editData.recommend_lesson_kr = data.content_all.recommend_lesson_kr || null;
      this.editData.student_lesson_time_kr = data.content_all.student_lesson_time_kr || null;
      this.editData.memo_kr = data.content_all.memo_kr || null;

      this.editData.recommend_lesson_jp = data.content_all.recommend_lesson_jp || null;
      this.editData.memo_jp = data.content_all.memo_jp || null;
    },

    addSignLesson() {
      if (this.signLessonModel.length === 5) { this.$message.warning('无法添加更多的课程'); } else { this.signLessonModel.push({}); }
    },

    /**
     * 同步到蓝火，填写信息
     * @param {Number} id
     */
    async syncToFib(id, message, to) {
      await this.$http._post({
        url: '/training/customer/syncToFib',
        data: { id, message, to }
      });
    },
    async syncToJob(id, message) {
      await this.$http._post({
        url: '/training/customer/syncToJob',
        data: { id, message }
      });
    },
    /**
     * 确认同步
     */
    async doSync({ system, message, to }) {
      const id = this.editData.id;
      if (system === CREATOR_TRAINING_TO_FIB) {
        await this.syncToFib(id, message, to);
      }

      if (system === CREATOR_TRAINING_TO_JOB) {
        await this.syncToJob(id, message);
      }
      this.$message.success('同步成功！');
      this.hideSyncDialog();
    },
    /**
     * 验证手机号码
     */
    checkTel(event) {
      let value = event.target.value.trim();
      if (value) {
        if (!this.checkMobile(value)) {
          this.$message.error('手机号码填写错误！');
          return false;
        }
        this.editData.tel = value;
      }
    },
    setNewCustomerData() {
      this.isNew = true;
      this.editData.creator = this.userInfo.userid;
      this.editData.create_point = -288;
      this.editData.custom_promoter = this.userInfo.userid;
    },
    syncDataLoaded(data) {
      this.syncDialog = data;
    },
    /**
     * 意向部门是否填写
     * @param {Object} targetCountry
     * @returns {Boolean}
     */
    hasTargetCountry(targetCountry) {
      return Object.values(targetCountry).some((item) => {
        return item;
      });
    },
    /**
     * 保存的数据
     */
    getData4Save() {
      let data = deepClone(this.editData);
      // 渠道
      data = Object.assign(data, this.channelModel);
      // 签约课程
      data = Object.assign(data, { sign_lesson: this.signLessonModel });

      // 学习目标
      if (data.study_goal.length > 0) {
        [data.study_goal_type, data.study_goal_level] = data.study_goal;
      }
      if (data.study_goal_kr && data.study_goal_kr.length > 0) {
        [data.study_goal_type_kr, data.study_goal_level_kr] = data.study_goal_kr;
      }

      // 最高学历
      if (data.education.length > 0) {
        [data.education_type, data.education_class] = data.education;
      }

      // 成绩信息
      data.scores = this.scores || scores;
      delete data.study_goal;
      delete data.study_goal_kr;
      delete data.education;
      delete data.visit_count;
      delete data.visit_time;
      return data;
    },
    // 复制点击
    copyClick() {
      this.$message.success('复制成功');
    },
  },
  computed: {
    /**
     * 咨询老师
     */
    trainingTeachers() {
      return this.ds.training_teacher;
    },
    // 用户运营老师
    opTeachers() {
      return this.ds.op_teacher;
    },
    // 教务老师
    jwTeachers() {
      return this.ds.jw_teacher;
    },
    // 可以编辑意向分级
    notEditTrainingLvType() {
      // 160 考培组长
      return !this.$hasPermission([160]);
    },
    // 可以编辑介绍人编码,91考培总监,85考培主管,154市场中心
    canEditIntroducerId() {
      return !this.$hasPermission([84, 85, 91, 154, 157]);
    },
    /**
     * 创建人为是否为当前登录者可编辑
     */
    canEditByCreator() {
      if (this.isNew) {
        return true;
      }
      return this.userInfo.userid === Number(this.editData.creator);
    },
    /**
     * 只读类信息
     */
    infoReadonly() {
      if (this.$hasPermission([1])) {
        return false;
      }
      // 其他系统信息只读
      if (!this.isTrainingSite || this.isSnapshot) {
        return true;
      }
      // 路由信息匹配
      if (this.$route.meta.c === 'trainingreuse') {
        return true;
      }
      // 新资源
      if (this.isNew) {
        return false;
      }
      // 咨询老师是自己
      if (this.userInfo.userid === Number(this.editData.training_teacher)) {
        return false;
      }
      // 推广人是自己
      if (this.userInfo.userid === Number(this.editData.custom_promoter)) {
        // 117用户运营，只允许新增，不允许修改
        if (this.$hasPermission([117])) {
          return true;
        }
        return false;
      }
      // 84考培运营，85考培主管, 91考培总监, 52学生编辑组（产品运营）, 165微课主管
      if (this.$hasPermission([1, 84, 85, 91, 52, 165])) {
        return false;
      }

      // if (!this.$hasPermission([81, 97, 117], true)) {
      //   return false;
      // }
      // if (this.$hasPermission([154, 81, 97, 117], true) && this.userInfo.userid === Number(this.editData.custom_promoter)) {
      //   return false;
      // }
      return true;
    },
    /**
     * 判断市场中心 154
     * @returns {boolean|*}
     */
    isMarketCenter() {
      return !this.isNew && this.$hasPermission([154], true) && this.userInfo.userid === Number(this.editData.custom_promoter);
    },
    /**
     * 修改咨询老师判断
     * @returns {boolean|*} 返回false，可修改，返回true 不可修改。
     */
    teacherModifyDisable() {
      // 新建资源可以修改咨询老师
      if (this.isNew) {
        return false;
      }

      // 管理员1，学生编辑组52，考培总监91，英澳培训总监139，考培主管85 可以修改咨询老师
      if (this.$hasPermission([1, 52, 91, 139, 85])) {
        return false;
      }

      // 考培组长160 ，可以修改其组成员的咨询老师
      if (this.$hasPermission([160])) {
        return false;
      }

      // 1：角色是考培运营84 2：资源推广人是自己，3：分配老师必须是-考培待下发承接账号2819340 才可修改
      if (this.$hasPermission([84], true) && this.userInfo.userid === Number(this.editData.custom_promoter) && Number(this.editData.training_teacher) === 2819340) {
        return false;
      }

      // 以上都不是的不能修改
      return true;
    },
  },
  created() {
    this.isNew = this.$route.meta.isNew || false;
    this.$nextTick(() => {
      let isTeacher = false;
      this.getDatasource().then((data) => {
        isTeacher = data.originTrainingTeacher.some((t) => {
          return t.userid === this.userInfo.userid;
        });
        if (isTeacher && this.isNew) {
          // this.editData.target_country = ['1868']; // 默认选择考培
          this.editData.training_teacher = this.userInfo.userid;
        }
      });
    });
  },
  watch: {
    'editData.target_lan' (lan) {
      let lanCols = [
        { key: 'japanese', label: ['日语'] },
        { key: 'korea', label: ['韩语'] },
        { key: 'english', label: ['雅思', '托福', 'PTE'] },
      ];

      lanCols.forEach(({ key, label }) => {
        // lan 与 label 求交集
        let arr = [];
        if (lan) {
          arr = lan.filter(v => label.indexOf(v) !== -1);
        }

        if (arr.length > 0) {
          this.activeNames.push(key);
        } else {
          this.activeNames = this.activeNames.filter(name => name !== key);
        }
      });
    }
  }
};

</script>

<style scoped>
  .webimlink {
    margin-left: 12px;
    padding: 4px 10px;
    background: #409eff;
    color: #fff;
    border-radius: 4px;
  }

  td:nth-child(odd) {
    word-break: keep-all;
  }

  .place {
    padding: 0 10px;
    background: #f3f3f3;
  }

  .basic-title {
    height: 35px;
    line-height: 35px;
    margin: 10px 8px 15px;
    position: relative;
    cursor: default;
    border-bottom: 1px solid #b8c4ce;
  }

  .basic-title em {
    display: block;
    float: left;
    width: 110px;
    height: 32px;
    font-size: 16px;
    line-height: 28px;
    text-indent: 8px;
    border-bottom: 4px solid #3368fa;
  }

  .basic-title em i {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-top: 6px;
    /* float: right; */
    margin-left: 8px;
    background-color: #3368fa;
    color: #fff;
    text-align: center;
    line-height: 15px;
    border-radius: 2px;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    text-indent: 0;
    vertical-align: middle;
    cursor: pointer;
  }

  .basic-table {
    width: 100%;
  }

  .basic-table th {
    padding: 3px 0;
    background-color: #e2eaf0;
    border-bottom: solid 1px #b8c4ce;
    cursor: pointer;
  }

  .basic-table th span {
    margin-left: 10px;
  }

  .basic-information {
    padding: 8px;
  }

  .basic-table th i {
    font-size: 14px;
    line-height: 26px;
  }

  .basic-table th i:after {
    display: inline-block;
    margin-left: 10px;
    content: "\e608";
  }

  .basic-table .el-row .el-col {
    display: flex;
    align-items: center;
    min-height: 55px;
    padding-left: 8px;
    border-right: solid 1px #b8c4ce;
    border-bottom: solid 1px #b8c4ce;
  }

  .basic-table-info .el-row:nth-child(2) .el-col {
    font-weight: bold;
  }

  .basic-table .scores-info .el-row .el-col {
    border-right: none;
    border-bottom: none;
    padding-left: 0;
  }

  .basic-table .scores-jmte {
    padding-left: 0 !important;
    border-bottom: none !important;
    border-right: none !important;
  }

  .mindMapping a {
    text-decoration: underline;
    color: #000;
  }

  .jm-span {
    display: inline-block;
    width: 80px;
    /* text-align: right; */
  }

  .basic-buttom {
    margin-top: 25px;
    text-align: center;
  }

  .title-bottom {
    float: right;
    margin: 0 20px;
  }

  .btn-send-msg {
    cursor: pointer;
  }

  .jm-studentEditBot {
    display: block;
    height: 100%;
    opacity: 1;
    margin-top: 3px;
  }

  .jm-tbody-hidden {
    display: none;
  }

  .el-collapse-item__header {
    background-color: #e2eaf0 !important;
  }

  .el-collapse-item {
    border-bottom: #b8c4ce solid 1px;
  }

  .edit-fixed {
    position: fixed;
    right: 70px;
    bottom: 256px;
    width: 35px;
    height: 35px;
    padding: 0;
    border-radius: 50%;
    text-align: center;
    z-index: 1;
    opacity: 0.7;
  }
</style>

<style>
  .diff_column input.el-input__inner {
    border-color: red;
  }

  .diff_column .el-select input.el-input__inner {
    border-color: red;
  }

  .basic-table-div .el-form-item__content {
    line-height: inherit !important;
  }
  .training-memo .el-textarea__inner{
    color: red;
    font-weight: bold;
  }
</style>
